import React from 'react'
import SettingShippingRulePage from "./SettingShippingRulePage"

function SettingShippingRuleContainer(props) {
    return (
        <div className="SettingShippingRuleContainer">
            <SettingShippingRulePage/>
        </div>
    )
}

export default SettingShippingRuleContainer